<template>
  <svg
    :style="`width:${size}; height:${size}; fill: ${color}`"
    class="inline-block"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 500 500"
    role="img"
    >
    <use :xlink:href="'/espacepersonnel/fonts/sprite.css.svg#'+name" />
  </svg>
</template>

<script>
export default {
  props: {
    name: String,
    size: String,
    color: {
      type: String,
      default: 'black'
    }
  }
};
</script>
